"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigManager = exports.EnvironmentList = void 0;
var qs_1 = __importDefault(require("qs"));
var custom_interception_1 = require("./custom-interception");
var util_1 = require("./util");
var loginUrl_1 = require("./loginUrl");
exports.EnvironmentList = ['development', 'test', 'staging', 'production'];
var ConfigManager = /** @class */ (function () {
    function ConfigManager(originalConfig) {
        this.originalConfig = originalConfig;
    }
    Object.defineProperty(ConfigManager.prototype, "baseConfig", {
        get: function () {
            var baseConfig = Object.assign(this.originalConfig);
            exports.EnvironmentList.forEach(function (env) { return delete baseConfig[env]; });
            var environmentConfig = this.originalConfig[process.env.NODE_ENV];
            return (0, util_1.mergeObjects)(baseConfig, environmentConfig);
        },
        enumerable: false,
        configurable: true
    });
    ConfigManager.prototype.getCustomInterceptor = function (baseConfig) {
        var options = {};
        return {
            applyOptions: function (requestOptions) {
                options = requestOptions;
            },
            onFulfilled: function (value) {
                var _a = (0, custom_interception_1.resolveCustomInterception)(baseConfig, options), validateResponse = _a.validateResponse, extractData = _a.extractData, extractErrorMessage = _a.extractErrorMessage, notifyMessage = _a.notifyMessage, showErrorMessage = _a.showErrorMessage, rethrowError = _a.rethrowError, transformResponse = _a.transformResponse, isUnauthorized = _a.isUnauthorized;
                // sso login failed
                if (isUnauthorized(value)) {
                    if (baseConfig.loginUrl) {
                        (0, loginUrl_1.redirectPageToLoginUrl)(baseConfig.loginUrl);
                        return;
                    }
                }
                if (validateResponse(value.data)) {
                    var data = extractData(value.data);
                    return transformResponse(data, value.headers);
                }
                var error = extractErrorMessage(value.data);
                var show = typeof showErrorMessage === 'function'
                    ? showErrorMessage(value)
                    : showErrorMessage;
                if (show) {
                    notifyMessage({
                        title: "\u4E1A\u52A1\u9519\u8BEF",
                        message: error,
                    });
                    if (rethrowError) {
                        throw error;
                    }
                }
                else {
                    throw error;
                }
            },
            onRejected: function (err) {
                var _a;
                if (((_a = err === null || err === void 0 ? void 0 : err.response) === null || _a === void 0 ? void 0 : _a.status) === 401) {
                    if (baseConfig.loginUrl) {
                        (0, loginUrl_1.redirectPageToLoginUrl)(baseConfig.loginUrl);
                        return;
                    }
                }
                var _b = (0, custom_interception_1.resolveCustomInterception)(baseConfig, options), notifyMessage = _b.notifyMessage, rethrowError = _b.rethrowError, showErrorMessage = _b.showErrorMessage;
                var show = typeof showErrorMessage === 'function'
                    ? showErrorMessage(err)
                    : showErrorMessage;
                if (show) {
                    notifyMessage({
                        title: "\u670D\u52A1\u7AEF\u9519\u8BEF",
                        message: err,
                    });
                    if (rethrowError) {
                        throw err;
                    }
                }
                else {
                    throw err;
                }
            },
        };
    };
    ConfigManager.prototype.getAxiosInstanceSetup = function () {
        var _a = this.baseConfig || {}, 
        // eslint-disable-next-line
        apiList = _a.apiList, loginUrl = _a.loginUrl, extractData = _a.extractData, extractErrorMessage = _a.extractErrorMessage, notifyMessage = _a.notifyMessage, showErrorMessage = _a.showErrorMessage, rethrowError = _a.rethrowError, validateResponse = _a.validateResponse, transformResponse = _a.transformResponse, isUnauthorized = _a.isUnauthorized, restBaseConfig = __rest(_a, ["apiList", "loginUrl", "extractData", "extractErrorMessage", "notifyMessage", "showErrorMessage", "rethrowError", "validateResponse", "transformResponse", "isUnauthorized"]);
        var defaultAxiosConfig = {
            paramsSerializer: function (params) {
                return qs_1.default.stringify(params);
            },
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
                'Content-Type': 'application/json',
            },
            timeout: 60 * 1000 * 10,
            withCredentials: true,
            responseType: 'json',
            // XSRF 设置
            xsrfCookieName: 'XSRF-TOKEN',
            xsrfHeaderName: 'X-XSRF-TOKEN',
            maxRedirects: 5,
            // maxContentLength: 2000, // 最大响应数据大小
            // 自定义错误状态码范围
            validateStatus: function (status) {
                return status >= 200 && status < 300;
            },
        };
        return {
            instanceConfig: __assign(__assign({}, defaultAxiosConfig), restBaseConfig),
            customInterceptor: this.getCustomInterceptor({
                loginUrl: loginUrl,
                transformResponse: transformResponse,
                notifyMessage: notifyMessage,
                showErrorMessage: showErrorMessage,
                extractData: extractData,
                extractErrorMessage: extractErrorMessage,
                rethrowError: rethrowError,
                validateResponse: validateResponse,
                isUnauthorized: isUnauthorized,
            }),
        };
    };
    return ConfigManager;
}());
exports.ConfigManager = ConfigManager;
